var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TOGGLE_BLUETOOTH_DELAY, ROLE_GET_SUCCEEDED, LANGUAGE_LOADED, LANGUAGE_CHANGED, MUTE_ALIAS_SOUNDS, CHANGE_SPEED, } from '../actions';
import { setLanguage } from '../../lib/translate';
var initialState = {
    bluetoothDelay: false,
    admin: false,
    language: 'no',
    mutedAliasSound: false,
    speed: 1,
};
var userReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case TOGGLE_BLUETOOTH_DELAY:
            return __assign(__assign({}, state), { bluetoothDelay: !state.bluetoothDelay });
        case ROLE_GET_SUCCEEDED:
            return __assign(__assign({}, state), { admin: action.data });
        case LANGUAGE_LOADED:
        case LANGUAGE_CHANGED:
            setLanguage(action.data);
            return __assign(__assign({}, state), { language: action.data });
        case MUTE_ALIAS_SOUNDS:
            return __assign(__assign({}, state), { mutedAliasSound: !state.mutedAliasSound });
        case CHANGE_SPEED:
            return __assign(__assign({}, state), { speed: action.data });
        default:
            return state;
    }
};
export default userReducer;
